import { Injectable } from '@angular/core';
import { FeatureService } from '../services/feature.service';
import { Observable } from 'rxjs';

@Injectable()
export class FeatureResolver {

  constructor(private featureService: FeatureService) {}

  init() {
    return this.featureService.isFeatureEnabled('InstallationV2').mergeMap((mainFeatureEnabled) => {
      if (mainFeatureEnabled) {
        let installation = this.featureService.getFeatureSettings('InstallationV2');
        let hasOrderLimit = this.featureService.hasFeature('OrderLimit');
        let hasWidgetV3Enabled = this.featureService.isFeatureEnabled('WidgetV3');
        let hasPostmanEditor = this.featureService.hasFeature('Postman');
        let map = this.featureService.getFeatureSettings('Map');
        return Observable.forkJoin(installation, hasOrderLimit, map, hasWidgetV3Enabled, hasPostmanEditor,
          (installationSettings, hasOrderLimitFeature, mapSettings, hasWidgetV3FeatureEnabled, hasPostmanEditorFeature) => {
            return {
              feature: {
                InstallationV2: {
                  step: installationSettings.response.step,
                  install_status: installationSettings.response.install_status
                },
                OrderLimit: {
                  hasFeature: hasOrderLimitFeature
                },
                WidgetV3: {
                  featureEnabled: hasWidgetV3FeatureEnabled
                },
                Postman: {
                  hasFeature: hasPostmanEditorFeature
                },
                Map: {
                  minimumContentNomineeCreationDate:  mapSettings.response.minimum_content_nominee_creation_date
                }
              }
            };
          });
      } else {
        return Observable.of({});
      }
    });
  }
}
